/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ScheduledTaskResponse
 */
export interface ScheduledTaskResponse {
    /**
     * 
     * @type {string}
     * @memberof ScheduledTaskResponse
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduledTaskResponse
     */
    taskType: string;
    /**
     * 
     * @type {Date}
     * @memberof ScheduledTaskResponse
     */
    startTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof ScheduledTaskResponse
     */
    endTime: Date;
    /**
     * 
     * @type {number}
     * @memberof ScheduledTaskResponse
     */
    durationMilliseconds: number;
    /**
     * 
     * @type {number}
     * @memberof ScheduledTaskResponse
     */
    taskExecutionId: number;
    /**
     * 
     * @type {string}
     * @memberof ScheduledTaskResponse
     */
    taskStatus: string;
}

/**
 * Check if a given object implements the ScheduledTaskResponse interface.
 */
export function instanceOfScheduledTaskResponse(value: object): value is ScheduledTaskResponse {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('taskType' in value) || value['taskType'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    if (!('endTime' in value) || value['endTime'] === undefined) return false;
    if (!('durationMilliseconds' in value) || value['durationMilliseconds'] === undefined) return false;
    if (!('taskExecutionId' in value) || value['taskExecutionId'] === undefined) return false;
    if (!('taskStatus' in value) || value['taskStatus'] === undefined) return false;
    return true;
}

export function ScheduledTaskResponseFromJSON(json: any): ScheduledTaskResponse {
    return ScheduledTaskResponseFromJSONTyped(json, false);
}

export function ScheduledTaskResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScheduledTaskResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['user_id'],
        'taskType': json['task_type'],
        'startTime': (new Date(json['start_time'])),
        'endTime': (new Date(json['end_time'])),
        'durationMilliseconds': json['duration_milliseconds'],
        'taskExecutionId': json['task_execution_id'],
        'taskStatus': json['task_status'],
    };
}

export function ScheduledTaskResponseToJSON(json: any): ScheduledTaskResponse {
    return ScheduledTaskResponseToJSONTyped(json, false);
}

export function ScheduledTaskResponseToJSONTyped(value?: ScheduledTaskResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_id': value['userId'],
        'task_type': value['taskType'],
        'start_time': value['startTime'].toISOString(),
        'end_time': value['endTime'].toISOString(),
        'duration_milliseconds': value['durationMilliseconds'],
        'task_execution_id': value['taskExecutionId'],
        'task_status': value['taskStatus'],
    };
}

